import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const StixWrapper = ({ children }) => {
  const scrollablePage = () => {
    let main = document.querySelector('[role="main"]')

    main.classList.add('stix-scrollable-area')
  }

  const returnOriginalState = () => {
    let main = document.querySelector('[role="main"]')

    main.classList.remove('stix-scrollable-area')
  }

  useEffect(() => {
    scrollablePage()

    return () => {
      returnOriginalState()
    }
  })

  return (
    <div className='container-stix container-fluid px-0 px-md-1 pt-0'>
      <div className='container pt-0 pb-3 py-md-5'>
        <div className='row pt-0'>
          {children}
        </div>
      </div>
    </div>
  )
}

StixWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export default StixWrapper



// WEBPACK FOOTER //
// ./src/features/Stix/StixWrapper.js